import * as Yup from 'yup';
import { CasReactHookFormDialog, CasRHFSelect } from 'src/compass/shared/components';
import { StringsToOptions } from 'src/compass/shared/util/StringsToOptions';
import { getSelectSchema } from 'src/compass/shared/schemas';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';
import { ClaimStatus } from '../../ClaimListing/ClaimListing';

const Schema = Yup.object().shape({
  status: getSelectSchema('Status'),
});

type Props = {
  url: string;
  endorsementId: number;
  onClose: VoidFunction;
  onUpdated: Function;
};

export default function ClaimDoneDialog({ url, endorsementId, onClose, onUpdated }: Props) {
  const { mutate } = useUpdateMutation({
    url,
    onSuccess: (response) => {
      onSuccessEnqueueSnackbar(response);
      onUpdated();
      onClose();
    },
  });

  const onSubmit = (payload: any) => mutate({ endorsementId, ...payload });

  return (
    <CasReactHookFormDialog
      open
      title="Reopen Claim"
      submitButtonLabel="Save"
      onClose={onClose}
      onSubmit={onSubmit}
      schema={Schema}
    >
      <CasRHFSelect
        name="status"
        label="Status"
        options={StringsToOptions([ClaimStatus.Send, ClaimStatus.Attached])}
      />
    </CasReactHookFormDialog>
  );
}
